import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/ServiceInfo.css';

const BusinessServicePage = () => {

  return (
    <div className="service-container">
      <h1 classname="service-title">Hizmet Tanıtımı ve Ödeme Bilgisi</h1>

      <p>
        <strong>halısahacım.com</strong>, halı saha işletmeleri ile futbol oynamak isteyen kullanıcıları bir araya getiren bir dijital platformdur.
      </p>

	<section>
      <h3>🎯 Hizmetin Amacı</h3>
      <p>
        İşletmelerin kendilerini daha geniş kitlelere tanıtmasını sağlarken, kullanıcıların da en uygun sahaları
        kolayca bulup rezervasyon yapabilmesine imkân sunar.
      </p>
	</section>

	<section>
      <h3>👥 Kimler İçin?</h3>
      <ul>
        <li>⚽ Halı saha işletmeleri (saha, ekipman, saatlik fiyat belirtebilir)</li>
        <li>👤 Futbol oynamak isteyen bireyler veya takımlar</li>
      </ul>
	</section>

	<section>
      <h3>💼 Sunulan Hizmetler</h3>
      <ul>
        <li>İşletme profili oluşturma</li>
        <li>Saha saatlerini ve fiyatlarını belirleme</li>
        <li>Kullanıcılardan rezervasyon talebi alma</li>
        <li>İşletme paneli üzerinden rezervasyonları yönetme</li>
        <li>Mesajlaşma ve değerlendirme sistemi</li>
      </ul>
	</section>

	<section>
      <h3>💳 Ödeme Bilgisi</h3>
      <p>
        İşletmeler <strong>halısahacım.com</strong> üzerinden <u>ilk ay ücretsiz</u> olarak hizmetten faydalanabilir.
        İlk ayın ardından işletmelerin listelenmeye devam edebilmesi için <strong>her 30 günde bir hizmet ücreti</strong> ödemesi gerekmektedir.
      </p>
      <ul>
        <li>⏱ Süreli üyelik yoktur.</li>
        <li>🛒 Satış yapılmaz, yalnızca platform listelenmesi sunulur.</li>
        <li>👁️‍🗨️ Ödeme yapılmadığı sürece işletmeler kullanıcılar tarafından görüntülenemez.</li>
      </ul>
	</section>

	<section>
      <h3>📌 Ücret</h3>
      <p><strong>Hizmet Ücreti:</strong> 1500 TL <em>(İlk ay ücretsizdir)</em></p>
	</section>

	<section>
      <h3>💳 Ödeme Yöntemi</h3>
      <p>
        İşletmeler ödeme sayfasına yönlendirilerek kart bilgileri ile güvenli bir şekilde ödeme yapabilir. 
        Ödeme, <strong>iyzico</strong> altyapısı üzerinden gerçekleştirilmektedir.
      </p>
	</section>

	<section>
      <h3>📬 İletişim</h3>
      <p>
        Hizmet hakkında daha fazla bilgi almak isterseniz bize <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> adresinden ulaşabilirsiniz.
      </p>
	</section>
    </div>
  );
};

export default BusinessServicePage;
